/*
    ajax请求函数模块
    返回值: promise对象(异步返回的数据是: response.data)
 */
import axios from 'axios';
// 导入 NProgress 包对应的JS和CSS
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {localCache} from '../utils/utils'
import {showLoading,hideLoading} from '../utils/loading'

// 在 request 拦截器中，展示进度条 NProgress.start()
axios.interceptors.request.use(config => {
    // console.log(config)
    NProgress.start();
    // showLoading();
    let token = localCache.get("token");
    // console.log(token);
    // 如果token不存在或过期需要条跳转到登录页面
    // this.$router.push("/login")
    config.headers.Authorization = token;
    // config.headers.Authorization = window.sessionStorage.getItem('token');
    // 在最后必须 return config
    return config
})
// 在 response 拦截器中，隐藏进度条 NProgress.done()
axios.interceptors.response.use(config => {
    NProgress.done();
    /*setTimeout(function (){
        hideLoading();
    },300)*/
    return config;
})
export default function ajax (url, data={}, type='GET') {
    return new Promise(function (resolve, reject) {
        // 执行异步ajax请求
        let promise;
        console.log(type);
        if (type.toUpperCase() === 'GET') {
            // 准备url query参数数据
            let dataStr = '' //数据拼接字符串
            Object.keys(data).forEach(key => {
                dataStr += key + '=' + data[key] + '&'
            })
            if (dataStr !== '') {
                dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
                url = url + '?' + dataStr
            }
            // 发送get请求
            promise = axios.get(url)
            console.log('url: ' + url);
            console.log("进入GET请求");
        } else if(type.toUpperCase() == 'POST') {
            // 发送post请求
            promise = axios.post(url, data);
            console.log('url: ' + url);
            console.log("进入POST请求");
        } else if(type.toUpperCase() == 'PUT') {
            promise = axios.put(url, data);
            console.log('url: ' + url);
            console.log("进入PUT请求");
        } else if(type.toUpperCase() == 'DELETE') {
            promise = axios.delete(url, data);
            console.log('url: ' + url);
            console.log("进入delete请求");
        } else {
            console.error('没有这种:' + type + '请求处理方式');
            return false;
        }
        promise.then(function (response) {
            // 成功了调用resolve()
            resolve(response.data)
        }).catch(function (error) {
            //失败了调用reject()
            reject(error)
        })
    })
}



// WEBPACK FOOTER //
// ./src/api/ajax.js